module.exports = __webpack_public_path__ + "static/img/增值税管理云6.55b9570b.png";